module.exports = __webpack_public_path__ + "static/media/cq_elimina_blu.9d8f25e0.svg";